"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionDescription_1 = __importDefault(require("./CollectionDescription"));
exports.default = CollectionDescription_1.default;
